import { StoryData } from "../../../../../store/content";

export const constructUrl = (baseUrl: string, storyData: StoryData) => {
  return baseUrl + "/" + storyData.id + "/" + storyData.tileUrl;
};
